// eslint-disable-next-line @byted/npcSdk/invalid-lerna-import
import jsrsasign from 'jsrsasign';
/**
 * @param data string
 * @returns base64 string
 */
export var convertStringToBase64 = function (data) {
    return jsrsasign.utf8tob64(data);
};
/**
 * @param data hex string
 * @returns base64 string
 */
export var convertHexToBase64 = function (data) {
    return jsrsasign.hextob64(data);
};
/**
 * @param data base64 string
 * @returns string
 */
export var convertBase64ToString = function (data) {
    return jsrsasign.b64toutf8(data);
};
